/*
 * @Author: Ljj
 * @Date: 2022-09-22 13:58:01
 * @LastEditors: Ljj
 * @LastEditTime: 2022-12-08 13:11:54
 * @Description: 批量导入
 */
import { requestByFormDataBlob } from '@/utils/request'
import { ref } from 'vue'

const useImportBlob = (uploadUrl, sendInfo) => {
  const importBlob = (payload) => requestByFormDataBlob(uploadUrl, payload)
  const filelist = ref([])
  const importStatus = ref(0)
  const successCount = ref(0)
  const errorCount = ref(0)
  const blob = ref('')
  const resultHeader = ref('')

  const importFile = async () => {
    if (importStatus.value === 0 && filelist.value.length) {
      importStatus.value = 1
      let payload = {
        ...sendInfo.value,
        file: filelist.value[0]
      }
      const result = await importBlob(payload)
      successCount.value = 0
      errorCount.value = 0
      resultHeader.value = result.headers['content-disposition']
      if (result.headers['content-disposition']) {
        const upLoadCount = decodeURIComponent(result.headers['content-disposition'].split('=')[1])
          .toString()
          .split('_')
        successCount.value = upLoadCount[1]
        errorCount.value = upLoadCount[2]
      }
      blob.value = new Blob([result.data], {
        type: result.data.type
      })
      importStatus.value = 2
    }
  }

  return {
    filelist,
    importStatus,
    importFile,
    successCount,
    successCount,
    errorCount,
    blob,
    resultHeader
  }
}

export default useImportBlob
